import { SiteContextService } from './../site-context.service';
import { IdentityService } from './../identity/identity.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class DontHaveSiteGuard {
  constructor(
    protected readonly identityService: IdentityService,
    protected readonly router: Router,
    private readonly siteContext: SiteContextService,
  ) {}
  public async canActivate() {
    const currentSite = await this.siteContext.getCurrentSiteAsync();
    if (currentSite) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}
